import { render, staticRenderFns } from "./VamosPaLaCalleHome.vue?vue&type=template&id=defabd84&scoped=true"
import script from "./VamosPaLaCalleHome.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defabd84",
  null
  
)

export default component.exports